import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9h.01","key":"svg-0"}],["path",{"d":"M11 12h1v4h1","key":"svg-1"}]]

/**
 * IconInfoSmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaW5mby1zbWFsbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgOWguMDEiIC8+CiAgPHBhdGggZD0iTTExIDEyaDF2NGgxIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/info-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconInfoSmall = createReactComponent('outline', 'info-small', 'InfoSmall', __iconNode);

export default IconInfoSmall;